"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagMasterSchema = void 0;
exports.TagMasterSchema = {
    "$id": "https://www.redbull.com/schemas/master/tags.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "TagMaster",
    "description": "A tag is the foundation of our taxonomy. It helps to intertwine our content.",
    "type": "object",
    "properties": {
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        },
        "type": {
            "enum": [
                "rrn:master:tags"
            ],
            "type": "string"
        },
        "relationships": {
            "type": "object",
            "properties": {
                "translations": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "properties": {
                                    "id": {
                                        "type": "string",
                                        "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
                                    },
                                    "type": {
                                        "enum": [
                                            "rrn:content:tags"
                                        ],
                                        "type": "string"
                                    }
                                }
                            }
                        }
                    }
                },
                "translatedFrom": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "object",
                            "properties": {
                                "id": {
                                    "type": "string",
                                    "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
                                },
                                "type": {
                                    "enum": [
                                        "rrn:content:tags"
                                    ],
                                    "type": "string"
                                }
                            }
                        }
                    }
                },
                "draftTranslations": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "properties": {
                                    "id": {
                                        "type": "string",
                                        "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
                                    },
                                    "type": {
                                        "enum": [
                                            "rrn:content:tags"
                                        ],
                                        "type": "string"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "additionalProperties": false
        },
        "meta": {
            "type": "object",
            "properties": {
                "published": {
                    "type": "boolean"
                },
                "status": {
                    "type": "string"
                },
                "version": {
                    "type": "number"
                },
                "dateCreated": {
                    "type": "string",
                    "pattern": "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{3}Z$"
                },
                "dateUpdated": {
                    "type": "string",
                    "pattern": "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{3}Z$"
                }
            }
        }
    },
    "required": [
        "id",
        "type",
        "relationships",
        "meta"
    ]
};
//# sourceMappingURL=data:application/json;base64,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